// src/components/course/ReviewButtonBar.js
import React from "react";

function ReviewButtonBar({ onSubmit, submitText = "입력" }) {
  const PRIMARY_COLOR = "rgb(0, 224, 198)";

  return (
    <div className="flex w-full">
      <button
        type="button"
        onClick={onSubmit}
        className="w-full h-14 rounded-2xl text-white text-base font-bold shadow-lg hover:opacity-90 transition-all active:scale-[0.98]"
        style={{ backgroundColor: PRIMARY_COLOR }}
      >
        {submitText}
      </button>
    </div>
  );
}

export default ReviewButtonBar;
